var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1297 15.2689C12.6331 16.5603 10.6918 17.34 8.57049 17.34C3.83714 17.34 0 13.4583 0 8.66998C0 3.88168 3.83714 0 8.57049 0C10.6918 0 12.6331 0.779624 14.1297 2.07108C15.6262 0.779624 17.5675 0 19.6888 0C24.4222 0 28.2593 3.88168 28.2593 8.66998C28.2593 13.4583 24.4222 17.34 19.6888 17.34C17.5675 17.34 15.6262 16.5603 14.1297 15.2689Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.13 15.2689C15.9728 13.6787 17.1413 11.3124 17.1413 8.66998C17.1413 6.0276 15.9728 3.66132 14.13 2.07108C15.6265 0.779623 17.5678 0 19.6891 0C24.4225 0 28.2596 3.88168 28.2596 8.66998C28.2596 13.4583 24.4225 17.34 19.6891 17.34C17.5678 17.34 15.6265 16.5603 14.13 15.2689Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1305 15.2689C15.9733 13.6787 17.1418 11.3124 17.1418 8.66998C17.1418 6.0276 15.9733 3.66132 14.1305 2.07108C12.2877 3.66132 11.1192 6.0276 11.1192 8.66998C11.1192 11.3124 12.2877 13.6787 14.1305 15.2689Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.740e65e24fa5a28ad2a2cc776ffec2ef.svg";
export { ForwardRef as ReactComponent };